import { ReactNode } from 'react';

import styles from './group.module.scss';

export function TwoColumnGroup({
  children,
  style,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={`page-content__column--two ${styles['two-column']}`}
      style={style}
    >
      {children}
    </div>
  );
}
